import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useDocumentState } from '@/state'

import type { TemplateAttribute } from '@/lib/api/client'

/**
 * 
   setDraggableAnnotationParentRef: (
    templateId: string,
    parentRef: HTMLDivElement | null,
  ) => void
  getDraggableAnnotationParentRef: (templateId: string) => HTMLDivElement | null


    setDraggableAnnotationParentRef: (
    templateId: string,
    parentRef: HTMLDivElement | null,
  ) =>
    set((state) => ({
      ...state,
      draggableAnnotationParentRefs: {
        ...state.draggableAnnotationParentRefs,
        [templateId]: {
          templateId,
          parentRef,
        },
      },
    })),
  getDraggableAnnotationParentRef: (templateId: string) =>
    get().draggableAnnotationParentRefs[templateId].parentRef || null,
 */
export const useRelativeToAbsolutePositioning = () => {
  const getDocumentState = useDocumentState(
    useShallow((state) => state.getState),
  )

  const setDraggableAnnotationParentRef = useDocumentState(
    useShallow((state) => state.setDraggableAnnotationParentRef),
  )

  const relativeToAbsolutePosition = useCallback(
    (template: TemplateAttribute) => {
      const templateId = template.id
      const templateValues = template.template_values as any

      if (!templateId) {
        return null
      }

      const { getDraggableAnnotationParentRef } = getDocumentState()

      const annotationParentRef = getDraggableAnnotationParentRef(templateId)

      if (!annotationParentRef) {
        return null
      }

      const annoParentY = annotationParentRef.parentElement
        ? annotationParentRef.parentElement.offsetTop
        : annotationParentRef.offsetTop

      const annoParentX = annotationParentRef.parentElement
        ? annotationParentRef.parentElement.offsetLeft
        : annotationParentRef.offsetLeft

      const posX = templateValues?.position?.x || 0
      const posY = templateValues?.position?.y || 0

      const y = annoParentY + posY
      const x = annoParentX + posX

      return { x, y }
    },
    [getDocumentState],
  )

  return {
    relativeToAbsolutePosition,
    setDraggableAnnotationParentRef,
  }
}
